/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import './MyStyles/style.css';
import './MyStyles/mobile-style.css';
import './MyStyles/site.css';
import './MyStyles/site2.css';

export const Footer = () => {
    return (
        <>
            <footer className="b-watcho-f">
                <div className="row">
                    <div className="col-md-6">
                    <p>©2025 VZY. All Rights Reserved. www.vzy.one or abbreviated VZY is an online video streaming service where visitors can access a variety of films, web series, Live TV serials, user generated content, etc., for which viewing rights are given by content copyright holders. VZY and all related channel and programming logos are service marks of, and all related programming audio-visuals and elements are the property of Dish Infra Services Private Limited.</p>
                    </div>
                    <div className="col-md-6">
                        <div className="w-app-logo">
                            <span>TV<br/> Platforms</span>
                            <ul>
                                <li>
                                    <a target="_blank" href="#">
                                        <img alt="androidtv" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-android-tv.png" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="#">
                                        <img src="Images/DKDOffer/f-logo2.svg" alt="" />
                                    </a>
                                </li>

                                <li>
                                    <a target="_blank" href="#">
                                        <img alt="apple" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-apple-tv.png" />
                                    </a>
                                </li>

                                <li>
                                    <a target="_blank" rel="noreferrer" href="#">
                                        <img src="Images/DKDOffer/f-logo4.svg" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="#">
                                        <img src="Images/DKDOffer/f-logo5.svg" alt="" />
                                    </a>
                                </li>

                            </ul>
                        </div>
                        <div className="w-app-logo">
                            <span>Mobile <br /> Platforms</span>
                            <ul>
                                <li>
                                    <a target="_blank" href="#"><img alt="iosapp" className="img-responsive " src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-ios-2.png"/></a>
                                </li>
                                <li>
                                    <a target="_blank" href="#"><img alt="android-mobile" className="img-responsive " src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/multi-device-android-mobile.png"/></a>
                                </li>
                            </ul>
                        </div>
                        <div className="w-app-logo">
                            <span>Set-Top-<br /> Box</span>
                            <ul>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://www.dishtv.in/">
                                        <img src="Images/dishTV-logo_New.png" alt="" />
                                    </a>
                                </li>
                                <li>
                                    <a target="_blank" rel="noreferrer" href="https://www.d2h.com/">
                                        <img src="Images/DKDOffer/f-logo9.svg" alt="" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer><section className="bottom_links">
                <ul>
                    <li><a href="https://www.vzy.one/en/supportPage/privacyPolicy" target="_blank">Privacy Policy</a></li>
                    <li><a href="https://www.vzy.one/en/supportPage/termsOfUse" target="_blank">Terms &amp; Conditions</a></li>
                    <li><a href="https://www.vzy.one/en/supportPage/grievance" target="_blank">Grievance</a></li>
                    <li><a href="https://www.vzy.one/en/supportPage/cookiePolicy" target="_blank">Cookies</a></li>
                    <li><a href="https://www.vzy.one/en/supportPage/aboutUs" target="_blank">About Us</a></li>
                    <li><a target="_blank">FAQ</a></li>
                </ul>
                <div className="w-share">
                    <div className="sharing">
                        <span>Connect with us :</span>
                    </div>
                    <ul>
                        <li>
                            <a target="_blank" ><img alt="facebook" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-facebook-follow.svg"/></a>
                        </li>
                        <li><a target="_blank" ><img alt="instagram" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-instagram-follow.svg"/></a></li>
                        <li>
                            <a target="_blank" ><img alt="twitter" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-twitter-follow.svg"/></a>
                        </li>
                        <li>
                            <a target="_blank" ><img alt="youtube" loading="lazy" src="https://d2ivesio5kogrp.cloudfront.net/static/watcho/images/ott-youtube-follow.svg"/></a>
                        </li>
                    </ul>
                </div>
            </section>

        </>
       
    );
}